import { render } from "./NewsOverview.vue?vue&type=template&id=4eec2252&scoped=true&ts=true"
import script from "./NewsOverview.ts?vue&type=script&lang=ts"
export * from "./NewsOverview.ts?vue&type=script&lang=ts"

import "./NewsOverview.scss?vue&type=style&index=0&id=4eec2252&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eec2252"]])

export default __exports__